/* OceanWash — LP2 Advertorial (lp2-adv-*) · scoped behaviour: review sliders, offer gallery, tier selection. */
(function () {
  'use strict';

  /* ---- Review slider (scroll-snap track + arrows) ---- */
  function initSlider(root) {
    if (root.dataset.lp2Init === '1') return;
    root.dataset.lp2Init = '1';
    var track = root.querySelector('.lp2-reviews__track');
    if (!track) return;
    var items = function () { return Array.prototype.slice.call(track.children); };

    function step() {
      var first = items()[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth;
      var s = step();
      var next = track.scrollLeft + dir * s;
      if (dir > 0 && track.scrollLeft >= max - 2) next = 0;           // wrap to start
      else if (dir < 0 && track.scrollLeft <= 2) next = max;          // wrap to end
      track.scrollTo({ left: Math.max(0, Math.min(max, next)), behavior: document.hidden ? 'auto' : 'smooth' });
    }
    root.querySelectorAll('.lp2-reviews__arrow--next').forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
    root.querySelectorAll('.lp2-reviews__arrow--prev').forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
  }

  /* ---- Offer gallery: thumbnails swap the main image ---- */
  function initGallery(root) {
    if (root.dataset.lp2Init === '1') return;
    root.dataset.lp2Init = '1';
    var main = root.querySelector('.lp2-offer__main img');
    var thumbs = root.querySelectorAll('.lp2-offer__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var srcset = t.getAttribute('data-srcset');
        if (src) main.setAttribute('src', src);
        if (srcset) main.setAttribute('srcset', srcset); else main.removeAttribute('srcset');
        var alt = t.querySelector('img');
        if (alt && alt.getAttribute('alt')) main.setAttribute('alt', alt.getAttribute('alt'));
        thumbs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        t.classList.add('is-active');
        t.setAttribute('aria-pressed', 'true');
      });
    });
  }

  /* ---- Offer tiers: visual selection + optional per-tier CTA link ---- */
  function initTiers(root) {
    if (root.dataset.lp2TiersInit === '1') return;
    root.dataset.lp2TiersInit = '1';
    var tiers = root.querySelectorAll('.lp2-tier');
    var cta = root.querySelector('.lp2-offer__cta');
    if (!tiers.length) return;
    function select(tier) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); t.setAttribute('aria-checked', 'false'); });
      tier.classList.add('is-selected');
      tier.setAttribute('aria-checked', 'true');
      var url = tier.getAttribute('data-url');
      if (cta && url) cta.setAttribute('href', url);
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(t); } });
    });
    var pre = root.querySelector('.lp2-tier.is-selected');
    if (pre) select(pre);
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-lp2-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-lp2-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-lp2-offer]').forEach(initTiers);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor: sections are re-rendered → re-init inside the new DOM */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
